import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useEffect } from 'modules/core/hooks/useEffect'

import { useExecuteReportQuery } from 'modules/reports/hooks/useExecuteReportQuery'
import { type ReportEditorStore } from 'modules/reports/lib/Store'

const ExecuteQueryModal = ({
  store,
  onClose,
}: {
  store: ReportEditorStore
  onClose: () => void
}) => {
  const { fetchData } = useExecuteReportQuery(store)

  // When fetch finishes, the store will be refreshed with its status and the modals rerendered
  useEffect(() => void fetchData(), []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal illustration="report-library" title="" onClose={onClose}>
      <Box alignItems="center">
        <Spinner />
      </Box>
    </Modal>
  )
}

export default observer(ExecuteQueryModal)
